import React, { useEffect, useState } from 'react';
import api from '../services/api';
import Modal from 'react-modal';
import Swal from 'sweetalert2';
import { FiEdit, FiTrash, FiPlus } from 'react-icons/fi';
// eslint-disable-next-line no-unused-vars
import { useAuth } from '../contexts/AuthContext';
import ConditionalButton from '../components/common/ConditionalButton';
import ConditionalActions from '../components/common/ConditionalActions';
import ResponsiveDataList from '../components/common/ResponsiveDataList';
import MobileCard from '../components/common/MobileCard';

const emptyIncident = { designation: '', retrait: '' };

const IncidentsPage = () => {
 // const { user } = useAuth();
  const [incidents, setIncidents] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [editing, setEditing] = useState(null);
  const [form, setForm] = useState(emptyIncident);
  const [search, setSearch] = useState('');

  useEffect(() => { fetchIncidents(); }, []);

  const fetchIncidents = async () => {
    const res = await api.get('/incidents');
    setIncidents(res.data.data || []);
  };

  const handleAdd = () => {
    setEditing(null);
    setForm(emptyIncident);
    setShowModal(true);
  };

  const handleEdit = (item) => {
    setEditing(item);
    setForm({ designation: item.designation || '', retrait: item.retrait || '' });
    setShowModal(true);
  };

  const handleDelete = async (id) => {
    const result = await Swal.fire({
      title: 'Supprimer cet incident ?',
      text: 'Cette action est irréversible.',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      cancelButtonColor: '#3085d6',
      confirmButtonText: 'Oui, supprimer',
      cancelButtonText: 'Annuler',
    });
    if (result.isConfirmed) {
      await api.delete(`/incidents/${id}`);
      fetchIncidents();
      Swal.fire('Supprimé !', 'L\'incident a été supprimé.', 'success');
    }
  };

  const handleModalClose = () => {
    setShowModal(false);
    setEditing(null);
    setForm(emptyIncident);
  };

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.designation) {
      Swal.fire({ icon: 'error', title: 'Erreur', text: 'La désignation est obligatoire.' });
      return;
    }
    const formToSend = {
      ...form,
      retrait: form.retrait ? String(form.retrait).replace('.', ',') : ''
    };
    if (editing) {
      await api.put(`/incidents/${editing.id}`, formToSend);
    } else {
      await api.post('/incidents', formToSend);
    }
    fetchIncidents();
    setShowModal(false);
  };

  const filteredIncidents = incidents.filter(i =>
    i.designation?.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <div>
      <div className="page-header">
        <h1 className="page-title">Incidents</h1>
        <ConditionalButton
          entity="incidents"
          permission="create"
          className="flex items-center space-x-2 bg-primary-600 text-white px-4 py-2 rounded-lg hover:bg-primary-700"
          onClick={handleAdd}
        >
          <FiPlus />
          <span>Nouvel incident</span>
        </ConditionalButton>
      </div>
      {/* Formulaire de recherche */}
      <div className="bg-white shadow rounded-lg overflow-x-auto mb-4 p-4">
        <input
          type="text"
          placeholder="Recherche par désignation..."
          value={search}
          onChange={e => setSearch(e.target.value)}
          className="border rounded px-3 py-2 w-full"
        />
      </div>
      <ResponsiveDataList
        isLoading={false}
        isEmpty={filteredIncidents.length === 0}
        emptyMessage="Aucun incident"
        mobileCards={filteredIncidents.map((item) => (
          <MobileCard
            key={item.id}
            title={item.designation}
            fields={[{ label: 'Retrait', value: item.retrait ? String(item.retrait).replace(',', '.') : '' }]}
            actions={
              <ConditionalActions
                entity="incidents"
                onEdit={() => handleEdit(item)}
                onDelete={() => handleDelete(item.id)}
                editIcon={FiEdit}
                deleteIcon={FiTrash}
                className="flex space-x-2"
              />
            }
          />
        ))}
      >
        <table className="min-w-full divide-y divide-gray-200">
          <thead className="bg-gray-50">
            <tr>
              <th className="px-6 py-3">Désignation</th>
              <th className="px-6 py-3">Retrait</th>
              <th className="px-6 py-3 text-right">Actions</th>
            </tr>
          </thead>
          <tbody className="bg-white divide-y divide-gray-200">
            {filteredIncidents.length === 0 ? (
              <tr>
                <td colSpan={3} className="px-6 py-4 text-center text-gray-500">Aucun incident</td>
              </tr>
            ) : (
              filteredIncidents.map((item) => (
                <tr key={item.id}>
                  <td className="px-6 py-4">{item.designation}</td>
                  <td className="px-6 py-4">{item.retrait ? String(item.retrait).replace(',', '.') : ''}</td>
                  <td className="px-6 py-4 text-right">
                    <ConditionalActions
                      entity="incidents"
                      onEdit={() => handleEdit(item)}
                      onDelete={() => handleDelete(item.id)}
                      editIcon={FiEdit}
                      deleteIcon={FiTrash}
                      className="flex space-x-2"
                    />
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </ResponsiveDataList>
      {/* Modal ajout/mise à jour */}
      <Modal
        isOpen={showModal}
        onRequestClose={handleModalClose}
        shouldCloseOnOverlayClick={false}
        contentLabel="Incident"
        ariaHideApp={false}
        style={{
            overlay: {
            backgroundColor: 'rgba(0,0,0,0.6)', // plus sombre, ajuste l'opacité si besoin
            zIndex: 1000
          },
          content: {
            maxWidth: '400px',
            width: '100%',
            margin: 'auto',
            borderRadius: 12,
            padding: 0,
            top: '50%',
            left: '50%',
            right: 'auto',
            bottom: 'auto',
            transform: 'translate(-50%, -50%)',
          }
        }}
      >
        <div className="flex justify-end p-2">
        <button
            type="button"
            onClick={handleModalClose}
            className="text-gray-400 hover:text-gray-700 text-2xl font-bold focus:outline-none"
            title="Fermer"
            style={{height: 36, minWidth: 36, lineHeight: '36px', borderRadius: '50%'}}
        >×</button>
        </div>
        <form onSubmit={handleSubmit} className="p-6">
          <h2 className="text-lg font-semibold mb-4">{editing ? 'Modifier' : 'Nouvel'} incident</h2>
          <div className="mb-4">
            <label className="block text-sm font-medium mb-1">Désignation *</label>
            <input
              type="text"
              name="designation"
              value={form.designation}
              onChange={handleChange}
              className="w-full border rounded px-3 py-2"
              required
            />
          </div>
          <div className="mb-4">
            <label className="block text-sm font-medium mb-1">Retrait</label>
            <input
              type="number"
              name="retrait"
              value={form.retrait ? String(form.retrait).replace(',', '.') : ''}
              onChange={handleChange}
              className="w-full border rounded px-3 py-2"
              step="0.01"
            />
          </div>
          <div className="flex justify-end gap-2">
            <button type="button" onClick={handleModalClose} className="px-4 py-2 rounded bg-gray-200 hover:bg-gray-300">Annuler</button>
            <ConditionalButton
              entity="incidents"
              permission={editing ? "update" : "create"}
              type="submit"
              className="px-4 py-2 rounded bg-primary-600 text-white hover:bg-primary-700"
            >
              {editing ? 'Enregistrer' : 'Créer'}
            </ConditionalButton>
          </div>
        </form>
      </Modal>
    </div>
  );
};

export default IncidentsPage;